import { Util } from "@/util/util";
import { Component, EsModuleComponent } from "vue/types/options";

export class VueLoaderService {
	private static instance: VueLoaderService;
	private receivedFirstLoadInstruction = false;
	private requestsInFlight: { [uuid: string]: Promise<Component | EsModuleComponent> } = {};

	private constructor() {
	}

	static getInstance(): VueLoaderService {
		if (VueLoaderService.instance == null) {
			VueLoaderService.instance = new VueLoaderService();
		}
		return VueLoaderService.instance;
	}

	static lazyLoadComponent(promise: Promise<Component | EsModuleComponent>): () => Promise<Component | EsModuleComponent> {
		return () => {
			const instance = this.getInstance();
			const uuid = Util.getUUID();
			instance.receivedFirstLoadInstruction = true;
			instance.requestsInFlight[uuid] = promise;
			instance.requestsInFlight[uuid].finally(() => {
				delete instance.requestsInFlight[uuid];
			});
			return instance.requestsInFlight[uuid];
		}
	}

	static finishedLoading(): Promise<void> {
		return new Promise<void>((resolve) => {
			this.getInstance().checkLoadingState(() => {
				resolve();
			});
		});
	}

	private checkLoadingState(whenDone: () => void): void {
		if (!this.receivedFirstLoadInstruction) {
			setTimeout(() => this.checkLoadingState(whenDone), 10);
			return;
		}

		const countKeys = Object.keys(this.requestsInFlight);
		if (countKeys.length <= 0) {
			setTimeout(() => whenDone(), 50);
			return;
		}
		setTimeout(() => this.checkLoadingState(whenDone), 10);
	}
}